import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import dayjs from "dayjs";
import Layout from "../../components/layout/Layout";
import {
  TextField,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Checkbox,
  Grid,
  FormGroup,
  FormControlLabel,
  MenuItem,
  Pagination,
  Select,
  Tabs,
  Tab,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useEffect, useState } from "react";
import useTable from "../../components/customHelpers/usePaginationTable";
import Notify from "../../components/customHelpers/Notify";
import Store from "../../actions/store";
import Category from "../../actions/Catagory";
import Product from "../../actions/product";
import Admin from "../../components/auth/Admin";

import CancelIcon from "@mui/icons-material/Cancel";
import Notification from "../../components/customHelpers/Notification";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import jsPDF from "jspdf";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { formatNumber, getTimestamp, pageSizes } from "../../utils/utils";
import FilterExportButtons from "./filterExportButton";

const initialHeadCells = [
  { id: "name", label: "Product Name", isVisible: true },
  { id: "sku", label: "Sku", isVisible: true },
  { id: "category", label: "Category", isVisible: true },
  { id: "store", label: "Store", isVisible: true },
  { id: "price", label: "Price", isVisible: true },
  { id: "quantity", label: "Quantity", isVisible: true },
  { id: "totalPrice", label: "Total Price", isVisible: true },
  { id: "createdAt", label: "CreatedAt", isVisible: true },
];

const InventoryReport = () => {
  const theme = useTheme();
  const [headCells, setHeadCells] = useState(initialHeadCells);
  const hiddenColumns = headCells.filter((cell) => !cell.isVisible);
  const { viewAllCatagories } = Category();
  const [categories, setCategories] = useState([]);

  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllStores } = Store();
  const { viewAllProductsListsWithPages, viewTotalPriceProductsLists } =
    Product();
  const [productLists, setProductLists] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelecetedCategory] = useState("");
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelecetedStore] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPrice, setTotalPrice] = useState({
    totalPrice: 0,
    isClick: true,
  });

  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(pageSizes[1]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getProductData();
  }, [
    page,
    limit,
    searchQuery,
    selectedCategory,
    selectedStore,
    startDate,
    endDate,
  ]);
  useEffect(() => {
    getAllStores();
    getAllCategories();
    getTotalPrice();
  }, []);
  useEffect(() => {
    getTotalPrice();
  }, [selectedCategory, selectedStore, startDate, endDate]);

  const getTotalPrice = () => {
    viewTotalPriceProductsLists(
      selectedCategory?.name || "",
      selectedStore ? selectedStore.locationName : "",
      startDate,
      endDate
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.totalPrice) {
        setTotalPrice({
          totalPrice: data.totalPrice || 0,
          isClick: true,
        });
      }
    });
  };

  const getAllStores = () => {
    setValues({ ...values, loading: true });
    viewAllStores().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.stores) {
        setValues({
          ...values,
          loading: false,
        });
        setStores(data.stores);
      }
    });
  };

  const getProductData = () => {
    viewAllProductsListsWithPages(
      page,
      limit,
      searchQuery,
      selectedCategory?.name || "",
      selectedStore ? selectedStore.locationName : "",
      startDate,
      endDate
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.product) {
        setValues({
          ...values,
          loading: false,
        });
        setProductLists(data.product);
        setProducts(data.product);
        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };

  const getAllCategories = () => {
    setValues({ ...values, loading: true });
    viewAllCatagories().then((data) => {
      if (data.err) {
        setValues({
          ...values,
          loading: false,
        });
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.categorys) {
        setValues({
          ...values,
          loading: false,
        });
        setCategories(data.categorys);
      }
    });
  };

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterSortingAndFiltering,
  } = useTable(productLists, initialHeadCells, filterFn);

  const handleCategoryChange = (e) => {
    setPage(1);
    setTotalPrice({ ...totalPrice, isClick: true });
    setSelecetedCategory(e);
  };

  const handleStoreChange = (e) => {
    setPage(1);
    setTotalPrice({ ...totalPrice, isClick: true });
    setSelecetedStore(e);
  };

  const handleStartDateChange = (newValue) => {
    setPage(1);
    setStartDate(newValue);
    setTotalPrice({ ...totalPrice, isClick: true });
  };

  const handleEndDateChange = (newValue) => {
    setPage(1);
    setEndDate(newValue);
    setTotalPrice({ ...totalPrice, isClick: true });
  };

  const generateReportFilename = (
    startDate,
    endDate,
    category,
    storeName,
    timestamp
  ) => {
    const formattedStartDate = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "AllDates";
    const formattedEndDate = endDate ? dayjs(endDate).format("YYYY-MM-DD") : "";
    const formattedCategory = category || "AllCategories";
    const formattedStore = storeName || "AllStores";

    return `${formattedStartDate}_${formattedEndDate}_${formattedCategory}_${formattedStore}_Inventory-report_${timestamp}`;
  };

  const exportToExcel = () => {
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const dataToExport = productLists.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "name":
            return item.product?.name;
          case "sku":
            return item.product?.sku;
          case "category":
            return item.product?.category;
          case "store":
            return item.store?.locationName;
          case "price":
            return item.price;
          case "quantity":
            return item.quantity;
          case "totalPrice":
            return item.price * item.quantity;
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );

    const totalPriceSum = productLists.reduce((sum, item) => {
      return sum + item.price * item.quantity;
    }, 0);
    dataToExport.push([
      "Total Price",
      totalPriceSum.toFixed(2),
      "",
      "",
      "",
      "",
      "",
      "",
    ]);
    const worksheet = XLSX.utils.aoa_to_sheet([
      filteredHeadCells.map((cell) => cell.label),
      ...dataToExport,
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const timestamp = getTimestamp();
    const filename = generateReportFilename(
      startDate,
      endDate,
      selectedCategory,
      selectedStore,
      timestamp
    );

    saveAs(blob, `${filename}.xlsx`);

    handleClose();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);

    const totalPriceSum = productLists.reduce((sum, item) => {
      return sum + item.price * item.quantity;
    }, 0);

    const bodyData = productLists.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "name":
            return item.product?.name;
          case "sku":
            return item.product?.sku;
          case "store":
            return item.store?.locationName;
          case "category":
            return item.product?.category;
          case "price":
            return item.price;
          case "quantity":
            return item.quantity;
          case "totalPrice":
            return item.price * item.quantity;
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );
    doc.autoTable({
      head: [filteredHeadCells.map((cell) => cell.label)],
      body: bodyData,
      styles: {
        fontSize: 10,
      },
      headStyles: {
        fillColor: [244, 151, 3],
        textColor: [20, 61, 89],
      },
    });

    const finalY = doc.lastAutoTable.finalY || 10;
    doc.text(
      `Total Price: ${formatNumber(totalPriceSum)}`,
      doc.internal.pageSize.getWidth() - 20,
      finalY + 10,
      { align: "right" }
    );

    const timestamp = getTimestamp();
    const filename = generateReportFilename(
      startDate,
      endDate,
      selectedCategory,
      selectedStore,
      timestamp
    );
    doc.save(`${filename}.pdf`);
    handleClose();
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const visibleColumns = headCells.filter((cell) => cell.isVisible);

  const handleColumnToggle = (id) => {
    const updatedHeadCells = headCells.map((cell) =>
      cell.id === id ? { ...cell, isVisible: !cell.isVisible } : cell
    );
    setHeadCells(updatedHeadCells);
  };

  const clearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setProductLists(products);
    setSelecetedCategory("");
    setSelecetedStore(null);
    setTotalPrice({ ...totalPrice, isClick: true });
    setPage(1);
    setLimit(25);
  };

  const handlePageChange = (event, newPage) => {
    setTotalPrice({ ...totalPrice, isClick: true });
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);
  const isMobile = useMediaQuery("(max-width:600px)");
  const ismedium = useMediaQuery("(min-width:650px) and (max-width:1100px)");

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Inventory Report
          </Typography>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent={{ xs: "flex-start", sm: "center" }}
            alignItems={{ xs: "stretch", sm: "center" }}
            gap={2}
            m={1}
            p={1}
          >
            <Box sx={{ width: { xs: "100%", sm: ismedium ? "30%" : "20%" } }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Start Date"
                    value={startDate}
                    onChange={handleStartDateChange}
                    slotProps={{
                      textField: {
                        InputLabelProps: { shrink: true },
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-root": { height: 45 },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Box sx={{ width: { xs: "100%", sm: ismedium ? "30%" : "20%" } }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="End Date"
                    value={endDate}
                    onChange={handleEndDateChange}
                    slotProps={{
                      textField: {
                        InputLabelProps: { shrink: true },
                      },
                    }}
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-root": { height: 43 },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Autocomplete
              options={categories}
              getOptionLabel={(option) => option.name}
              value={selectedCategory || null}
              onChange={(event, newValue) => handleCategoryChange(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Filter By Category" />
              )}
              sx={{
                marginBottom: "8px",
                width: { xs: "100%", sm: ismedium ? "30%" : "20%" },
                "& .MuiInputBase-root": { height: 48 },
              }}
            />

            <Autocomplete
              options={stores}
              getOptionLabel={(option) => option.locationName}
              value={selectedStore || null}
              onChange={(event, newValue) => handleStoreChange(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Filter By Store" />
              )}
              sx={{
                marginBottom: "8px",
                width: { xs: "100%", sm: "20%" },
                "& .MuiInputBase-root": { height: 48 },
              }}
            />
            {!ismedium && (
              <FilterExportButtons
                clearFilters={clearFilters}
                exportToPDF={exportToPDF}
                exportToExcel={exportToExcel}
              />
            )}
          </Box>
          {ismedium && (
            <FilterExportButtons
              clearFilters={clearFilters}
              exportToPDF={exportToPDF}
              exportToExcel={exportToExcel}
            />
          )}
          <Grid container spacing={2}>
            {isMobile && hiddenColumns.length > 0 && (
              <Grid item xs={12} sx={{ display: { xs: "block", sm: "none" } }}>
                <Typography variant="h6">Hidden Columns</Typography>
                <FormGroup sx={{ marginTop: 0 }}>
                  {hiddenColumns.map((headCell, index) => (
                    <FormControlLabel
                      key={headCell.id}
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              backgroundColor: "transparent",
                            },
                          }}
                          checked={!headCell.isVisible}
                          onChange={() => handleColumnToggle(headCell.id)}
                        />
                      }
                      label={headCell.label}
                      sx={{
                        marginBottom:
                          index === hiddenColumns.length - 1 ? 0 : 1,
                        "& .MuiFormControlLabel-label": {
                          marginTop: 0,
                        },
                      }}
                    />
                  ))}
                </FormGroup>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sm={hiddenColumns.length > 0 ? 9 : 12}
              className="card__body"
            >
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <Table>
                      <TableHead>
                        <TableRow
                          style={{
                            height: "30px",
                            maxHeight: "30px",
                            minHeight: "30px",
                          }}
                        >
                          {visibleColumns.map((headCell) => (
                            <TableCell
                              key={headCell.id}
                              className={
                                headCell.isVisible
                                  ? "table-cell-visible"
                                  : "table-cell-hidden"
                              }
                              style={{
                                width: headCell.isVisible ? "auto" : "0",
                                fontWeight: 600,
                                color: "rgb(20,61,89)",
                                backgroundColor: "rgba(244,151,3,.8)",
                                userSelect: "text",
                                pointerEvents: "auto",
                                padding: "2px 4px",
                                fontSize: "0.9rem",
                                lineHeight: "1.2rem",
                                height: "30px",
                                maxHeight: "30px",
                                minHeight: "30px",
                              }}
                            >
                              <Box
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: "4px",
                                  height: "100%",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  noWrap
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "0.9rem",
                                    lineHeight: "1rem",
                                  }}
                                >
                                  {headCell.label}
                                </Typography>

                                <Checkbox
                                  checked={headCell.isVisible}
                                  onChange={() =>
                                    handleColumnToggle(headCell.id)
                                  }
                                  icon={
                                    <CheckBoxOutlineBlankIcon fontSize="small" />
                                  }
                                  checkedIcon={<CancelIcon fontSize="small" />}
                                  style={{
                                    padding: 0,
                                    margin: 0,
                                  }}
                                />
                              </Box>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {recordsAfterSortingAndFiltering().length > 0 ? (
                          recordsAfterSortingAndFiltering().map((item) => (
                            <TableRow key={item.id}>
                              {visibleColumns.map((headCell) => (
                                <TableCell key={headCell.id}>
                                  {headCell.id === "name"
                                    ? item.product?.name
                                    : headCell.id === "sku"
                                    ? item.product?.sku
                                    : headCell.id === "category"
                                    ? item.product?.category
                                    : headCell.id === "store"
                                    ? item.store?.locationName
                                    : headCell.id === "price"
                                    ? item.price
                                    : headCell.id === "quantity"
                                    ? item.quantity
                                    : headCell.id === "totalPrice"
                                    ? item.price * item.quantity
                                    : headCell.id === "createdAt"
                                    ? new Date(item.createdAt).toLocaleString()
                                    : null}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                        ) : (
                          <Norecords col={6} />
                        )}
                      </TableBody>
                    </Table>
                  </TblContainer>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      p: 2,
                      backgroundColor: "background.paper",
                      borderTop: 1,
                      borderColor: "divider",
                      gap: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                      <Typography variant="body2" sx={{ mr: 1 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        size="small"
                        sx={{ minWidth: 120 }}
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {productLists.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                      />
                    )}
                  </Box>
                  <Box display="flex" justifyContent="end" gap={2} m={1} p={1}>
                    <div
                      style={{
                        marginRight: "35px",
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      Total Price:{" "}
                      {totalPrice.isClick
                        ? formatNumber(totalPrice.totalPrice)
                        : formatNumber(
                            productLists.reduce((sum, item) => {
                              return sum + item.price * item.quantity;
                            }, 0)
                          )}
                    </div>
                  </Box>
                </Paper>
              )}
            </Grid>
            {!isMobile && hiddenColumns.length > 0 && (
              <Grid
                item
                xs={2}
                sx={{ display: { xs: "none", sm: "block" }, marginLeft: 10 }}
              >
                <Typography variant="h6">Hidden Columns</Typography>
                <Grid container spacing={1}>
                  {hiddenColumns.map((headCell, index) => (
                    <Grid item xs={6} key={headCell.id}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{
                              "& .MuiSvgIcon-root": {
                                backgroundColor: "transparent",
                              },
                            }}
                            checked={!headCell.isVisible}
                            onChange={() => handleColumnToggle(headCell.id)}
                          />
                        }
                        label={headCell.label}
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            marginTop: 0,
                          },
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            )}
            <Notification notify={notify} setNotify={setNotify} />
          </Grid>
        </div>
      </Admin>
    </Layout>
  );
};

export default InventoryReport;
